import { ChainType } from "@0xsquid/squid-types";
import { UseMutationResult } from "@tanstack/react-query";
import React, { createContext, ReactNode, useContext } from "react";
import { useXrpl } from "../../hooks/xrpl/useXrpl";
import { ConnectWalletResult, XrplWallet } from "../types/wallet";
import { XrplConnector } from "../types/xrpl";

export interface IXrplContextData {
  connectXrpl: UseMutationResult<
    ConnectWalletResult<ChainType.XRPL>,
    unknown,
    {
      wallet: XrplWallet;
    },
    unknown
  >;
  disconnectXrpl: () => Promise<void>;
  autoConnectXrpl: () => Promise<void>;
  signer: XrplConnector | undefined;
  wallets: XrplWallet[];
}

export const XrplContext = createContext<IXrplContextData | undefined>(
  undefined
);

export const XrplProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const xrplContext = useXrpl();

  return (
    <XrplContext.Provider value={xrplContext}>{children}</XrplContext.Provider>
  );
};

export const useXrplContext = (): IXrplContextData => {
  const context = useContext(XrplContext);
  if (!context) {
    throw new Error("useXrplContext must be used within a XrplProvider");
  }
  return context;
};
